import { ShaderMaterial } from "three";

const vertexShader = /* glsl */ `
in vec3 aCenter;
in float aFill;
in float aChip;
in float aAlpha;
in vec3 aColor;
in float aElite;
out vec2 vUv;
out vec3 vColor;
out float vElite;
out float vFill;
out float vChip;
out float vAlpha;

void main() {
  vUv = uv;
  vFill = aFill;
  vChip = aChip;
  vAlpha = aAlpha;
  vColor = aColor;
  vElite = aElite;
  // Billboard no espaço da câmera: sempre de frente, e cresce com a distância até 2,5× para
  // continuar legível sem tapar a criatura de perto.
  vec4 view = viewMatrix * vec4(aCenter, 1.0);
  float scale = clamp(-view.z / 10.0, 1.0, 2.5);
  view.xy += position.xy * vec2(0.8, 0.09) * scale;
  gl_Position = projectionMatrix * view;
}
`;

const fragmentShader = /* glsl */ `
in vec2 vUv;
in float vFill;
in float vChip;
in float vAlpha;
in vec3 vColor;
in float vElite;

void main() {
  // Moldura escura de ~1 px (pela derivada; a elite ganha uma de ~3 px na cor do tom), fundo
  // translúcido, faixa branca do dano recente (chip) e o preenchimento na cor do tom (F75: laranja do
  // inimigo, vermelho do chefe, neutro da fauna), que apaga um pouco quando esvazia.
  vec2 edge = min(vUv, 1.0 - vUv) / fwidth(vUv);
  float px = min(edge.x, edge.y);
  float border = 1.0 - step(1.5, px);
  float eliteRim = vElite * (1.0 - step(3.5, px)) * (1.0 - border);
  vec3 fill = vColor * mix(0.7, 1.0, vFill);
  vec3 color = vec3(0.06);
  float alpha = 0.55;
  // O chip contrasta com o preenchimento: branco nas barras de cor, cinza na barra clara da fauna.
  float light = dot(vColor, vec3(0.2126, 0.7152, 0.0722));
  if (vUv.x < vChip) { color = light > 0.5 ? vec3(0.18) : vec3(0.92); alpha = 0.9; }
  if (vUv.x < vFill) { color = fill; alpha = 1.0; }
  color = mix(color, vColor, eliteRim);
  alpha = max(alpha, eliteRim);
  color = mix(color, vec3(0.03), border);
  alpha = max(alpha, border * 0.9);
  gl_FragColor = vec4(color, alpha * vAlpha);
  #include <colorspace_fragment>
}
`;

/** Barras de vida das criaturas (doc 05, marcadores): quads instanciados num único draw. */
export function createHealthBarMaterial(): ShaderMaterial {
  return new ShaderMaterial({
    name: "barra-de-vida",
    vertexShader,
    fragmentShader,
    transparent: true,
    depthWrite: false,
  });
}
